import client from 'api/client';
import { AxiosRequestConfig, AxiosResponse } from 'axios';

export function getTopScore(id?: number | string, lang?: string) {
    let path = `/assessment/qualified-visa-programs`;
    if (id != null) {
        path += `/${id}`;
    }
    if (lang != null) {
        path += `?language=${lang}`;
    }
    return client.get(path);
}

export function getAllQualifiedServices(id?: number | string, lang?: string) {
    let path = `/assessment/all-qualified-services`;
    if (id != null) {
        path += `/${id}`;
    }
    if (lang != null) {
        path += `?language=${lang}`;
    }
    return client.get(path);
}

export function submitAssessment(customConfig?: AxiosRequestConfig) {
    return client.get('/assessment', customConfig);
}

export function getAssessment(
    id: number,
    country?: string,
    language?: string
): Promise<AxiosResponse<Blob>> {
    const url = id ? `/assessment/report/${id}` : '/assessment/report';
    return client.get<Blob>(url, {
        responseType: 'blob',
        headers: { 'Content-Type': 'binary/octet-stream' },
        params: {
            ...(country ? { country } : {}),
            ...(language ? { language } : {}),
        },
    });
}

//only to be fetched from admin
export function getNewAssessment(
    id: number,
    country: string,
    lang: string
): Promise<AxiosResponse<Blob>> {
    const url = `/assessment/report/${id}?country=${country}&language=${lang}`;
    return client.get<Blob>(url, {
        responseType: 'blob',
        headers: { 'Content-Type': 'binary/octet-stream' },
    });
}

export function deleteApplication(applicationId: number): Promise<AxiosResponse> {
    const url = `/agreement/${applicationId}`;
    return client.delete(url);
}
